@if (loading() === true) {
  <mat-spinner diameter="36" mode="indeterminate"></mat-spinner>
} @else {
  <div class="buttons-container">
    @if (status() === 'Open') {
      @if (lostStage(); as lostStage) {
        <button mat-flat-button type="button" color="warn" class="button-lost" (click)="updateStage(lostStage)">
          {{ 'OPPORTUNITY.ACTIONS.CLOSE_LOST' | translate }}
        </button>
      }
      @if (wonStage(); as wonStage) {
        <button mat-flat-button type="button" color="primary" class="button-won" (click)="updateStage(wonStage)">
          {{ 'OPPORTUNITY.ACTIONS.CLOSE_WON' | translate }}
        </button>
      }
    } @else {
      @if (firstOpenStage(); as firstOpenStage) {
        <button mat-stroked-button type="button" (click)="updateStage(firstOpenStage)">
          {{ 'OPPORTUNITY.ACTIONS.REOPEN' | translate }}
        </button>
      }
    }
  </div>
}
